<template>
   <v-text-field
      v-model="localValue"
      :label="`${required ? '* ' + label : label}`"
      :loading="loading"
      :placeholder="placeholder"
      :clearable="clearable"
      :rules="
         required ? [() => !!localValue || `${label} es requerido.`] : []
      "
      :error="pushError"
      :counter="maxlength"
      :maxlength="maxlength"
      :type="type"
      :class="isCenter ? 'custom centered-input' : 'custom'"
      @keyup="custom"
      :hint="hint"
      :disabled="disabled"
      :max="max"
      :min="min"
   ></v-text-field>
</template>

<script>
//Mixins
import vmodel from '../js/mixins/vmodel'

export default {
   mixins: [vmodel],
   props: {
      clearable: { type: Boolean },
      placeholder: { type: String },
      pushError: { type: Boolean },
      loading: { type: Boolean },
      required: { type: Boolean },
      maxlength: { type: String },
      type: { type: String },
      isCenter: { type: Boolean },
      onlyNumber: { type: Boolean },
      hint: { type: String },
      disabled: { type: Boolean },
      min: { type: String },
      max: { type: String }
   },
   methods: {
      custom() {
         if (this.onlyNumber) {
            let newValue = ''
            for (let char of this.localValue)
               if (/[0-9]/.test(char)) newValue += char
            this.localValue = newValue
         }
      }
   }
}
</script>

<style scoped>
.centered-input >>> input {
   text-align: center;
}
.custom >>> input {
   font-size: 1.2em;
}
.custom >>> label {
   font-size: 1.2em;
}
</style>
